<template>
  <formulaire-view
    :steps="steps"
    :step="step"
    url="/demande-permis-pharmacien-equivalence/"
    paramsName="equivalence_internationale"
    :endpoint="endpoint"
    showPanier
    :getRefs="$refs"
  >
    <template v-slot:step="{ sas, path, setState, code }">
      <component :is="path" :sas="sas" @validation-changed="setState(path, $event)" :ref="path" :endpoint="endpoint">
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/views/FormulaireView.vue"
import Identification from "@/components/Formulaires/PermisEquivalence/Identification"
import Cours from "@/components/Formulaires/PermisEquivalence/Cours"
import EvaluationComparativeEtudes from "@/components/Formulaires/PermisEquivalence/EvaluationComparativeEtudes"
import ExamenBepc from "@/components/Formulaires/PermisEquivalence/ExamenBepc"
import ConnaissanceLangueFrancaise from "@/components/Formulaires/PermisEquivalence/ConnaissanceLangueFrancaise"
import ExperiencesProfessionnelles from "@/components/Formulaires/PermisEquivalence/ExperienceProfessionnelle"
import FormationContinue from "@/components/Formulaires/PermisEquivalence/FormationContinue"
import Publications from "@/components/Formulaires/PermisEquivalence/Publications"
import ParticipationComites from "@/components/Formulaires/PermisEquivalence/ParticipationComites"
import ActiviteDeRecherche from "@/components/Formulaires/PermisEquivalence/ActiviteDeRecherche"
import OrdresProfessionnels from "@/components/Formulaires/PermisEquivalence/OrdresProfessionnels"
import ObjectifsCarriere from "@/components/Formulaires/PermisEquivalence/ObjectifCarriereFormation"
import DeclarationsJudiciaires from "@/components/form_parts/DeclarationsJudiciaires"
import Declaration from "@/components/Formulaires/PermisEquivalence/Declaration"
import Diplomes from "@/components/Formulaires/PermisEquivalence/Diplomes"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "demande-permis-pharmacien-equivalence",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "diplomes", code: "titre-etape-2", state: "" },
        { path: "evaluation-comparative-etudes", code: "titre-etape-3", state: "" },
        { path: "cours", code: "titre-etape-4", state: "" },
        { path: "examenBepc", code: "titre-etape-5", state: "" },
        { path: "connaissance-langue-francaise", code: "titre-etape-6", state: "" },
        { path: "experiences-professionnelles", code: "titre-etape-7", state: "" },
        { path: "formation-continue", code: "titre-etape-8", state: "" },
        { path: "publications", code: "titre-etape-9", state: "" },
        // { path: "participation-comites", code: "titre-etape-10", state: "" },
        // { path: "activite-de-recherche", code: "titre-etape-11", state: "" },
        { path: "ordres-professionnels", code: "titre-etape-12", state: "" },
        { path: "declarations-judiciaires", code: "titre-etape-13", state: "" },
        { path: "objectifs-carriere", code: "titre-etape-14", state: "" },
        { path: "declaration", code: "titre-etape-15", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },
  components: {
    FormulaireView,
    Identification,
    Diplomes,
    EvaluationComparativeEtudes,
    Cours,
    ExamenBepc,
    ConnaissanceLangueFrancaise,
    ExperiencesProfessionnelles,
    FormationContinue,
    Publications,
    ParticipationComites,
    ActiviteDeRecherche,
    OrdresProfessionnels,
    Declaration,
    ObjectifsCarriere,
    DeclarationsJudiciaires
  }
}
</script>
